var _a;
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["AdminPortalIntegrated"] = "adminPortalIntegrated";
})(FeatureFlag || (FeatureFlag = {}));
export default {
    environments: {
        'stage-intelligence.heidricknavigator.com': {
            featureFlags: {},
        },
        'test-intelligence.heidricknavigator.com': {
            featureFlags: {},
        },
        'stage-insights.headrickassessment.com': {
            featureFlags: {},
        },
        'test-insights.headrickassessment.com': {
            featureFlags: {},
        },
        'localhost': {
            featureFlags: {},
        },
        'default': {
            featureFlags: (_a = {},
                _a[FeatureFlag.AdminPortalIntegrated] = true,
                _a),
        },
    },
    clientIdFeeders: [
        {
            referrerRegex: "\.*boozallenhamilton\.*",
            client: "66d0b7c41658e1da3e357b00",
        },
    ],
};
